<div class="title" style="text-align: left">
    Set Up Authenticator App MFA
</div>

<form name="setupTotpMfaForm" [formGroup]="setupForm" novalidate (ngSubmit)="onFormSubmit($event)">
    <div class="mfa-login-setup-info">
        <div>1. Open an authenticator app on your phone.</div>

        <div>2. Scan the QR code or enter the secret key.
            <qrcode style="text-align: center;"
                    [qrdata]="uri"
                    [width]="256"
                    [errorCorrectionLevel]="'M'"
            ></qrcode>

            <mat-form-field class="mfa-phone" appearance="fill">
                <mat-label>Secret Key</mat-label>
                <input matInput type="text" [formControl]="secretKeyCtrl" tabIndex="1">
                <button mat-icon-button
                        matSuffix
                        matTooltip="Copy Value"
                        [matTooltipClass]="'font-size-13'"
                        aria-hidden="true"
                        ngxClipboard
                        [cbContent]="secretKeyCtrl?.value"
                        (cbOnSuccess)="onCopySecretKeyToClipboard()"
                >
                    <mat-icon>content_copy</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div>3. Enter the code from the app to verify.
            <mat-form-field class="mfa-phone" appearance="fill">
                <mat-label>Confirmation Code</mat-label>
                <input matInput type="text" formControlName="confirmationKey" tabIndex="2">
                <mat-error *ngIf="setupForm?.controls?.confirmationKey?.errors" class="mt-4">Confirmation Code is invalid
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button mat-button
                type="button"
                class="submit-button"
                color="primary"
                aria-label="Cancel"
                (click)="onCancel()"
        >
            Cancel
        </button>
        <button mat-raised-button
                class="submit-button"
                color="primary"
                aria-label="Send code"
                [disabled]="setupForm.invalid || (loading$ | async)"
                type="submit"
        >
            Verify
        </button>
    </mat-dialog-actions>
</form>
